export const Role = {
    Admin: 'Admin',
    Management: 'Management',
    Owner: 'Owner'
}